<template>
  <div class="animated fadeIn narasumber">
        <b-card v-if="showList">
          <div slot="header">Narasumber/Talent 
            <div class="card-header-actions">
              <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
              <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
            </div>
          </div>
        <b-row >
          <b-col lg="7">
              <b-input-group >
                  <b-input-group-prepend><span class="pt-2 mr-2">Filter of </span></b-input-group-prepend>
                  <b-form-input v-model="filter.nama" placeholder="NAMA"></b-form-input>
                  <b-form-input v-model="filter.npwp" class="ml-1" placeholder="NPWP"></b-form-input>
              </b-input-group>
          </b-col>
          <b-col md="3">
                <b-row>
                  <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                  <b-button class="btn btn-secondary mr-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
                </b-row>
          </b-col>
        </b-row>

          <b-table
            class="mb-0"
            ref="table"
            outlined  responsive hover small
            style="font-size:smaller;" 
            :items="data"
            :fields="tblFields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"

            @row-clicked="rowClicked"
          >
            <template v-slot:cell(action)="data">
              <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
                <template v-slot:button-content>
                  <i class="fa fa-play text-primary"></i>
                </template>
                <b-dropdown-item @click="edit(data.item)" href="#"  style="padding:0 !important;" >Edit</b-dropdown-item>
                <b-dropdown-item @click="deleteConfirm(data.item)" href="#"  style="padding:0 !important;" > Delete</b-dropdown-item>
              </b-dropdown>
            </template>        

            <template v-slot:cell(nomor)="data">
              {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
            </template>

         </b-table>
          <b-row class="mt-2">
            <b-col cols="6">
              <div>
                Showing {{(tblData.page - 1) * tblData.limit + 1}}
                to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
                of {{tblData.total}} entries
              </div>
            </b-col>
            <b-col cols="6">            
              <b-pagination
                align="right"
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
            </b-col>
          </b-row>

          <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
            <p class="mb-1">1 record is about to be permanently deleted</p>
            <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
          </b-modal>
        </b-card>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col lg="8" xl="6">
        <b-card >
          <div slot="header">Narasumber/Talent - Add/Edit Form </div>
              <b-input-group>
                  <b-input-group-prepend><label>Nama Lengkap</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.nama" :state="!$v.frmdata.nama.$error"></b-form-input>
                  <b-form-radio-group class="ml-2 mt-2" v-model="frmdata.pria" name="radioTerminate">
                    <b-form-radio value="0">Wanita</b-form-radio>
                    <b-form-radio value="1">Pria</b-form-radio>
                  </b-form-radio-group>
              </b-input-group>
              <b-input-group>
                  <b-input-group-prepend><label>Alamat Tinggal</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.alamat" ></b-form-input>
              </b-input-group>
              <b-input-group>
                  <b-input-group-prepend><label>Tlp./HP</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.tlpHp" ></b-form-input>
                    <b-input-group-prepend><span class="ml-2 pt-1 mr-1" style="width:70px;">EMAIL</span></b-input-group-prepend>
                  <b-form-input v-model="frmdata.email" ></b-form-input>
              </b-input-group>

              <b-input-group>
                <b-input-group-prepend><label>NIK/KTP</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.ktp" ></b-form-input>
                    <b-input-group-prepend><span class="ml-2 pt-1 mr-1" style="width:70px;">NPWP</span></b-input-group-prepend>
                  <b-form-input v-model="frmdata.npwp" :state="!$v.frmdata.npwp.$error"></b-form-input>
              </b-input-group>
              <b-input-group>
                  <b-input-group-prepend><label>Alamat NPWP</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.alamat_npwp" ></b-form-input>
              </b-input-group>
              <b-input-group >
                <b-input-group-prepend><label>Status Nikah</label></b-input-group-prepend>
                  <b-form-select v-model="frmdata.statusNikah" :plain="true" :options="maritalStatus"></b-form-select>
                  <b-input-group-prepend><span class="pt-2">&nbsp; Tanggungan &nbsp; </span></b-input-group-prepend>    
                  <b-form-input v-model="frmdata.tanggungan" type="number"></b-form-input>
                  <b-input-group-prepend><span class="input-group-text">anak</span></b-input-group-prepend>    
              </b-input-group>
              <b-row>
                  <b-col lg="6">
                      <b-input-group>
                          <b-input-group-prepend><label>No.Rekening </label></b-input-group-prepend>
                          <b-form-input v-model="frmdata.norek" ></b-form-input>
                      </b-input-group>
                  </b-col>
                  <b-col lg="6">
                    <b-input-group>
                        <b-input-group-prepend><span class="pt-2 mr-2">BANK </span></b-input-group-prepend>
                        <b-form-input v-model="frmdata.norek_bank" ></b-form-input>
                    </b-input-group>
                  </b-col>
              </b-row>
              <b-row>
                  <b-col lg="8">
                      <b-input-group>
                          <b-input-group-prepend><label style="width:180px;">Nama Nasabah pd Rekening</label></b-input-group-prepend>
                          <b-form-input v-model="frmdata.norek_nasabah" ></b-form-input>
                      </b-input-group>
                  </b-col>
              </b-row>

            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
              </button>
             <b-button variant="secondary" class="mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<style lang="scss">
  .narasumber {
    table {
      td {
        .dropdown-item {
            padding: 0.1rem 1.5rem !important;
            font-size: smaller !important;
        }    
      }
    }
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 100px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
      .input-group {
          .input-group-prepend {
              label {
                  width: 110px !important;
              }
          }
      }

    }
 }
</style>

<script>
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import crudexport from "../../apis/crudexport";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
        nama: { required },
        npwp: { required }
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      showList:true,
      showForm:false,
      frmdata:{nama: '',npwp:1 },
      tblData: {
        tablename:'narasumber',
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'nama',
        sortDesc: false,
      },
      filter:{ nama:'', npwp:''},
      activeStatus : [{ value: '', text: '-- ALL --' },, { value: '0', text: 'Non Active' },{ value: '1', text: 'Active/In Use' }],
      maritalStatus: [{value:0,text:'BELUM MENIKAH'},{value:1,text:'MENIKAH'},{value:-1,text:'CERAI DG ANAK'}],
    };
  },
  computed: {
    tblFields(){
      const fields=[
          {
            key: "action",
            label: "",
            thStyle: "width:40px",
            thClass: "text-center",
          },
          {
            key: "nomor",
            label: "No.",
            thStyle: "width:60px"
          },
          {
            key: "nama",
            label: "Nama",
            sortable: true
          },
          {
            key: "alamat",
            label: "Alamat",
            sortable: true
          },
          {
            key: "npwp",
            label: "NPWP",
            sortable: true
          },
          {
            key: "tlpHp",
            label: "Tlp/HP",
            sortable: true
          },
          {
            key: "email",
            label: "Email",
            sortable: true
          },
          {
            key: "norek",
            label: "No.Rekening",
            sortable: true
          },
          {
            key: "norek_bank",
            label: "No.Rek Bank",
            sortable: true
          },
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },

  },
  methods: {
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      let str ='isdeleted=0';
      if (this.filter.nama){
        str += str ? '&' : '';
        str = str + 'nama=%' + encodeURIComponent(this.filter.nama)+'%';
      }
      // if (this.filter.npwp){
      //   str += str ? '&' : '';
      //   str = str + 'npwp=' + encodeURIComponent(this.filter.npwp)+'';
      // }
      this.tblData.customQuery=str;      
      const list = await crud.list(this.tblData);      
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    add: function(data) {
        this.frmdata.nama = '';
        this.frmdata.tlpHp = '';
        this.frmdata.email = '';
        this.frmdata.alamat = '';
        this.frmdata.ktp = '';
        this.frmdata.npwp = '';
        this.frmdata.alamat_npwp = '';
        this.frmdata.norek = '';
        this.frmdata.norek_bank = '';
        this.frmdata.norek_nasabah = '';
        this.frmdata.tanggungan = 0;
        this.frmdata.pria = 1;
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        this.frmdata.nama = '';
        this.frmdata.tlpHp = '';
        this.frmdata.email = '';
        this.frmdata.alamat = '';
        this.frmdata.ktp = '';
        this.frmdata.npwp = '';
        this.frmdata.alamat_npwp = '';
        this.frmdata.norek = '';
        this.frmdata.norek_bank = '';
        this.frmdata.norek_nasabah = '';
        this.frmdata.tanggungan = 0;
        this.frmdata.pria = 0;
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.frmdata.idlama = data._id;
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              if (this.frmdata.idlama) {
                await crud.update(
                     {tablename:'narasumber', 
                     key:this.frmdata.idlama, 
                     data:{nama:this.frmdata.nama.toUpperCase(),
                     tlpHp: this.frmdata.tlpHp,
                     email: this.frmdata.email,
                     alamat: this.frmdata.alamat,
                     ktp: this.frmdata.ktp,
                     npwp: this.frmdata.npwp,
                     alamat_npwp: this.frmdata.alamat_npwp,
                     pria: this.frmdata.pria,
                     statusNikah: this.frmdata.statusNikah,
                     tanggungan: this.frmdata.tanggungan,
                     norek: this.frmdata.norek,
                     norek_bank: this.frmdata.norek_bank,
                     norek_nasabah: this.frmdata.norek_nasabah,
                     }
                      });
              } else {
                await crud.insert(
                  { tablename:'narasumber',                      
                     data:{nama:this.frmdata.nama.toUpperCase(),
                     tlpHp: this.frmdata.tlpHp,
                     email: this.frmdata.email,
                     alamat: this.frmdata.alamat,
                     ktp: this.frmdata.ktp,
                     npwp: this.frmdata.npwp,
                     alamat_npwp: this.frmdata.alamat_npwp,
                     pria: this.frmdata.pria,
                     statusNikah: this.frmdata.statusNikah,
                     tanggungan: this.frmdata.tanggungan,
                     norek: this.frmdata.norek,
                     norek_bank: this.frmdata.norek_bank,
                     norek_nasabah: this.frmdata.norek_nasabah,
                     }
                  });
              }
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({tablename:'narasumber', key:this.model._id});
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    clearFilter(ctx) {
        this.filter.nama= '';
        this.filter.npwp= '';
        this.refresh();
    },    
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push({path:"home"});
    },    
  }
};
</script>
